const clearRewardsState = (state) => {
  state.reward_advertisers = [];
  state.reward_being_edited = null;
}

const addReward = (state, payload) => {
  var alreadyPresent = false;

  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === payload.advertiser_id) {
      var rewardAlreadyPresent = false;
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) {
        if (state.reward_advertisers[j].rewards[i].id === payload.reward.id) {
          rewardAlreadyPresent = true;
        }
      }

      if (!rewardAlreadyPresent) {
        state.reward_advertisers[j].rewards.push(payload.reward);
      }
      alreadyPresent = true;
    }
  }

  if (!alreadyPresent) {
    const newRewardAdvertiser = {
      id: payload.advertiser_id,
      rewards: [payload.reward],
    }
    state.reward_advertisers.push(newRewardAdvertiser);
  }
}

const updateRewardBeingEdited = (state, newRewardBeingEdited) => {
  state.reward_being_edited = newRewardBeingEdited;
}

const updateRewardLiveStatus = (state, payload) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === payload.merchant_id) {
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) { 
        if (state.reward_advertisers[j].rewards[i].id === payload.reward_id) {
          state.reward_advertisers[j].rewards[i].live = payload.status
        }
      }
    }
  }
}

const updateRewardArchivedStatus = (state, payload) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === payload.merchant_id) {
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) { 
        if (state.reward_advertisers[j].rewards[i].id === payload.reward_id) {
          state.reward_advertisers[j].rewards[i].is_archived = payload.is_archived;
        }
      }
    }
  }
}

const updateRewardDetails = (state, payload) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === payload.advertiser_id) {
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) { 
        if (state.reward_advertisers[j].rewards[i].id === payload.id) {
          state.reward_advertisers[j].rewards[i].description = payload.description
          state.reward_advertisers[j].rewards[i].point_value = payload.point_cost
          if (payload.redeem_through_promocode) {
            if (payload.redeem_online) {
              state.reward_advertisers[j].rewards[i].reward_type = 'Promo Code (online)'
            } else {
              state.reward_advertisers[j].rewards[i].reward_type = 'Promo Code (point of sale)'
            }
          } else {
            if (payload.redeem_online) {
              state.reward_advertisers[j].rewards[i].reward_type = 'Website URL (no code)'
            } else {
              state.reward_advertisers[j].rewards[i].reward_type = 'In-Store'
            }
          }
          state.reward_advertisers[j].rewards[i].promo_code = payload.promocode_single
          state.reward_advertisers[j].rewards[i].link_url = payload.link_url
          state.reward_advertisers[j].rewards[i].per_user_weekly_limit = payload.per_user_weekly_limit
          state.reward_advertisers[j].rewards[i].daily_limit = payload.maximum_redemptions_per_day
          state.reward_advertisers[j].rewards[i].weekly_limit = payload.maximum_redemptions_per_week
          state.reward_advertisers[j].rewards[i].shopify_price_rule_id = payload.shopify_price_rule_id
        }
      }
    }
  }
}

const updateReward = (state, payload) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === payload.advertiser_id) {
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) { 
        if (state.reward_advertisers[j].rewards[i].id === payload.id) {
          state.reward_advertisers[j].rewards[i].title = payload.title
          state.reward_advertisers[j].rewards[i].live = payload.live
          state.reward_advertisers[j].rewards[i].description = payload.description
          state.reward_advertisers[j].rewards[i].point_value = payload.point_value
          state.reward_advertisers[j].rewards[i].reward_type = payload.reward_type
          state.reward_advertisers[j].rewards[i].promo_code = payload.promo_code
          state.reward_advertisers[j].rewards[i].link_url = payload.link_url
          state.reward_advertisers[j].rewards[i].per_user_weekly_limit = payload.per_user_weekly_limit
          state.reward_advertisers[j].rewards[i].daily_limit = payload.daily_limit
          state.reward_advertisers[j].rewards[i].weekly_limit = payload.weekly_limit
          state.reward_advertisers[j].rewards[i].last_edited = payload.last_edited
          state.reward_advertisers[j].rewards[i].shopify_price_rule_id = payload.shopify_price_rule_id
        }
      }
    }
  }
}

export default {
  clearRewardsState,
  addReward,
  updateRewardBeingEdited,
  updateRewardLiveStatus,
  updateRewardArchivedStatus,
  updateRewardDetails,
  updateReward,
}